import React from "react";

export default function TemplateList() {
  return (
    <div
      style={{
        display: "flex",
        flex: 1,
        borderWidth: "5px",
        background: "red",
      }}
    ></div>
  );
}

const styles = {
  container: {
    height: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    // justifyContent: "center",
    backgroundColor: "white",
    //justifySelf: "stretch",
  },
  header: {},
  body: {},
};
